const catalog = {
    main: $('.js-catalog-list-main')
}
$(document).on('click', '.js-view-item', function() {
    $('.js-view-item').removeClass('current');
    $(this).addClass('current');
});

$(document).on('click', '.js-sentence-button', function() {
    const item = $(`.js-sentence-box[data-id="${$(this).data('id')}"]`);

    if (item.hasClass('current')) {
        item.removeClass('current');
    } else {
        $('.js-sentence-box').removeClass('current');
        item.addClass('current');
    }
});
$(document).on('click', function(e) {
    if ($(e.target).closest('.sentenceItem').length === 0 && $(e.target).closest('.js-sentence-button').length === 0) {
        $('.js-sentence-box').each(function(i, item) {
            $(item).removeClass('current');
        });
    }
});
$(document).on('click', '.js-sentence-item-close', function() {
    $('.js-sentence-box').removeClass('current');
});